import { apiClient } from '@/lib/api/client'
import type {
  AuthResponse,
  LoginDto,
  RegisterDto,
  RegisterResponseDto,
  RegistrationStatusResponseDto,
} from '@fp3/shared'

export const authApi = {
  register: async (dto: RegisterDto): Promise<RegisterResponseDto> => {
    const { data } = await apiClient.post<RegisterResponseDto>('/auth/register', dto)
    return data
  },

  login: async (dto: LoginDto): Promise<AuthResponse> => {
    const { data } = await apiClient.post<AuthResponse>('/auth/login', dto)
    return data
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout')
  },

  verifyEmail: async (token: string): Promise<{ message: string }> => {
    const { data } = await apiClient.post<{ message: string }>('/auth/verify-email', { token })
    return data
  },

  resendVerification: async (email: string): Promise<{ message: string }> => {
    const { data } = await apiClient.post<{ message: string }>('/auth/resend-verification', {
      email,
    })
    return data
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const { data } = await apiClient.post<{ message: string }>('/auth/forgot-password', { email })
    return data
  },

  resetPassword: async (token: string, password: string): Promise<{ message: string }> => {
    const { data } = await apiClient.post<{ message: string }>('/auth/reset-password', {
      token,
      password,
    })
    return data
  },

  getRegistrationStatus: async (): Promise<RegistrationStatusResponseDto> => {
    const { data } = await apiClient.get<RegistrationStatusResponseDto>('/auth/registration-status')
    return data
  },
}
